/**
 * N° de directive d'un extra, pour l'affichage (avenants, extras).
 *
 * D'abord la nomenclature de la directive liee (extra.directive_id), puis le
 * numero saisi a la main (co_number, texte libre), sinon null.
 * Un extra cree depuis une directive a directive_id mais pas de co_number.
 *
 * Accepte l'objet brut (snake_case) comme l'objet camelCase des services ;
 * la directive liee vient de l'embed PostgREST `directive:project_directives
 * !project_extras_directive_id_fkey(nomenclature)` (deux cles relient ces
 * tables : le nom de la cle est obligatoire).
 */
export const EXTRA_DIRECTIVE_EMBED = 'directive:project_directives!project_extras_directive_id_fkey(nomenclature)';

export const extraDirectiveNumber = (extra) =>
  extra?.directive?.nomenclature?.trim()
  || (extra?.coNumber ?? extra?.co_number)?.trim()
  || null;
